import { MenuItem } from "@kaltura/ds-react-components";
import { MenuItemOnCallbackDataProps, ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

type AnalyticsProps = {
    pageName: string;
    buttonType: ButtonClickAnalyticsType;
    id?: string;
};

export interface ActionMenuItemProps {
    /** id to be used by the menu item */
    id?: string;
    /** menu item label */
    label: string;
    /** callback function to be called after action is performed */
    onCallback: (data: MenuItemOnCallbackDataProps) => void;
    /** focus the item automatically when opening the menu */
    autoFocus?: boolean;
    /** optional analytics props */
    analytics?: AnalyticsProps;
}

/**
 * An item for ActionsMenu that doesn't contain a link and triggers a callback on click
 */
export const ActionMenuItem = (props: ActionMenuItemProps) => {
    const { label, onCallback, autoFocus, id, analytics } = props;
    const sendButtonAnalytics = useButtonAnalytics();

    const onMenuButtonClick = () => {
        if (analytics?.pageName && analytics?.buttonType) {
            sendButtonAnalytics(analytics.pageName, analytics.buttonType, analytics.id);
        }

        onCallback({ id });
    };

    return (
        <MenuItem autoFocus={autoFocus} onClick={onMenuButtonClick}>
            {label}
        </MenuItem>
    );
};
